export let OSCILAR_TRANSACTION_ID: string | undefined;
export let OSCILAR_TAB_ID: string | undefined;

type OjsIDs = { transactionID: string; tabID: string };
const generateOscilarTransactionId = (w: Window & { __ojsdk__?: { getIDs?: Array<(ojsIDs: OjsIDs) => void> } }) => {
  const __ojsdk__ = (w.__ojsdk__ = w.__ojsdk__ || {});
  __ojsdk__.getIDs = __ojsdk__.getIDs || [];

  __ojsdk__.getIDs.push(({ transactionID, tabID }: OjsIDs) => {
    OSCILAR_TRANSACTION_ID = transactionID;
    OSCILAR_TAB_ID = tabID;
    (w as any).__oscilar_transaction_id = transactionID;
    (w as any).__oscilar_tab_id = tabID;
    console.debug('🚀 ~ generateOscilarTransactionId ~ OSCILAR_TRANSACTION_ID:', OSCILAR_TRANSACTION_ID);
    console.debug('🚀 ~ generateOscilarTransactionId ~ OSCILAR_TAB_ID:', OSCILAR_TAB_ID);
  });
};

export function loadOscilarScript(loaderURL: string): void {
  if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    const script = document.createElement('script');
    script.src = loaderURL;
    script.async = true; // Load script asynchronously to avoid blocking
    script.defer = true; // Ensure script executes after the DOM is parsed
    script.onload = () => {
      generateOscilarTransactionId(window);
    };
    script.onerror = () => console.error(`Failed to load script ${script.src}.`);
    document.head.appendChild(script);
  }
}

type CommitPayload = { userID: string; accountID?: string };
interface Ojsdk {
  commit: any[];
  getIDs: any[];
}

export const isOscilarLoaded = (): boolean => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return false;
  const sdk = (window as any)?.__ojsdk__;
  return Boolean(sdk && typeof sdk === 'object');
};

export const oscilarCommit = (
  w: Window & { __ojsdk__?: { commit?: Array<CommitPayload & OjsIDs>; getIDs?: Array<(ojsIDs: OjsIDs) => void> } },
  payload: CommitPayload
) => {
  if (typeof document === 'undefined' || !isOscilarLoaded()) {
    // Makes sure not to ever run this on the server
    return;
  }

  const __ojsdk__: Ojsdk = (w.__ojsdk__ = {
    commit: w.__ojsdk__?.commit || [],
    getIDs: w.__ojsdk__?.getIDs || [],
  });

  __ojsdk__.commit.push({ ...payload });
};
